import React from 'react';
import { Box, Typography, Paper, Tabs, Tab } from '@mui/material';
import EmailTemplatesTab from './components/EmailTemplatesTab';
import EmailSendRecordsTab from './components/EmailSendRecordsTab';

const Emails = () => {
  const [tab, setTab] = React.useState(0);

  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
        E-posta Kanalları
      </Typography>
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Tabs
          value={tab}
          onChange={(e, value) => setTab(value)}
          sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
        >
          <Tab label="E-posta Şablonları" />
          <Tab label="Gönderim Kayıtları" />
        </Tabs>
        {tab === 0 && <EmailTemplatesTab />}
        {tab === 1 && <EmailSendRecordsTab />}
      </Paper>
    </Box>
  );
};

export default Emails;


